import React from 'react';
import { Redirect } from 'react-router-dom';

import { settingsPosTrackingMethodLocationsPath } from '../../../Paths';

export default () => <Redirect to={settingsPosTrackingMethodLocationsPath} />;
